module.exports = __webpack_public_path__ + "static/media/1.da7cfae4.jpg";